// extracted by mini-css-extract-plugin
export default {"checkBox":"CheckBox_checkBox__j4FOI"};